import React, { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { api, setSeo } from "@/lib/api";
import ProductGrid from "@/components/ProductGrid";

export default function Sale() {
  useEffect(() => setSeo("Sale | Up to 30% Off Modest Fashion | Adam's Boutique", "Shop the Adam's sale — discounted abayas, hijabs & jilbabs. Premium modest fashion at special prices."), []);
  const { data = [], isLoading } = useQuery({ queryKey: ["sale"], queryFn: async () => (await api.get("/products?flag=sale")).data });

  return (
    <div>
      <section className="bg-espresso py-16 lg:py-24 text-center">
        <div className="max-w-2xl mx-auto px-6">
          <p className="text-champagne-light overline mb-3">Limited Time</p>
          <h1 className="font-serif text-5xl lg:text-6xl text-ivory">The Sale</h1>
          <p className="text-ivory/70 mt-4 font-sans">Timeless pieces, thoughtfully reduced. Elegance for less — while stocks last.</p>
        </div>
      </section>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-8 py-12 lg:py-16">
        <ProductGrid products={data} loading={isLoading} cols={4} paginate pageSize={12} />
      </div>
    </div>
  );
}
